export default __webpack_public_path__ + "static/media/help--submit.9e095707.png";